"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setGroups = exports.setFilters = exports.triggerFilterReset = exports.handleFilterResponse = exports.SET_FILTER_GROUPS = exports.TRIGGER_FILTER_RESET = exports.HANDLE_FILTER_RESPONSE = exports.SET_FILTER_ITEMS = exports.FILTER_ITEMS = void 0;
exports.FILTER_ITEMS = '[FilterItems]';
exports.SET_FILTER_ITEMS = `${exports.FILTER_ITEMS} SET`;
exports.HANDLE_FILTER_RESPONSE = 'HANDLE_FILTER_RESPONSE';
exports.TRIGGER_FILTER_RESET = 'TRIGGER_FILTER_RESET';
exports.SET_FILTER_GROUPS = 'FILTER_GROUPS_SET';
const handleFilterResponse = ({ response }) => ({
    type: exports.HANDLE_FILTER_RESPONSE,
    payload: response,
    meta: { feature: exports.FILTER_ITEMS },
});
exports.handleFilterResponse = handleFilterResponse;
const triggerFilterReset = () => ({
    type: exports.TRIGGER_FILTER_RESET,
    meta: { feature: exports.FILTER_ITEMS },
});
exports.triggerFilterReset = triggerFilterReset;
const setFilters = ({ filterItems }) => ({
    type: exports.SET_FILTER_ITEMS,
    payload: filterItems,
    meta: { feature: exports.FILTER_ITEMS },
});
exports.setFilters = setFilters;
const setGroups = ({ filterGroups }) => ({
    type: exports.SET_FILTER_GROUPS,
    payload: filterGroups,
    meta: { feature: exports.FILTER_ITEMS },
});
exports.setGroups = setGroups;
//# sourceMappingURL=filters.js.map